import { createContext } from 'react'
// Additional
import { Routing } from 'helpers/routing'

const MatchContext = createContext<{ params?: Routing.MatchParams }>({})

export { MatchContext }